export default __webpack_public_path__ + "static/media/facebookWhite.3f34314f.svg";